import styled from 'styled-components';
import { StyledModal } from '../Modals-styled';


export const ShortLinkModal = styled(StyledModal)`
	& .ant-modal-body .anticon {
		color: ${({ theme }) => theme.colors.fallow};
	}

	& .ant-modal-body a {
		user-select: all;
	}

	& .ant-modal-body .anticon-copy {
		padding-left: 3px;
	}
		& .ant-modal-body .anticon-copy:hover {
			color: inherit;
		}

	& .ant-modal-body .anticon-loading-3-quarters {
		padding-right: 5px;
	}
`;